import { render, staticRenderFns } from "./CostContractSupplierList.vue?vue&type=template&id=08f0f246&"
import script from "./CostContractSupplierList.vue?vue&type=script&lang=js&"
export * from "./CostContractSupplierList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08f0f246')) {
      api.createRecord('08f0f246', component.options)
    } else {
      api.reload('08f0f246', component.options)
    }
    module.hot.accept("./CostContractSupplierList.vue?vue&type=template&id=08f0f246&", function () {
      api.rerender('08f0f246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/cost-contract-supplier/CostContractSupplierList.vue"
export default component.exports